import { Receipt } from '@mui/icons-material';
import { Box, Chip, Pagination } from '@mui/material';
import { FC, useState } from 'react';
import { SidePanelLayout } from '@lendica/components';
import { bucket_name, awsURL } from '../payLaterAPI';

export interface Invoice {
    name: string;
    filename: string;
}

export const PdfViewer: FC<{ invoices: Invoice[] }> = ({ invoices }) => {
    // TODO: set selectedInvoice to 0 when route changes
    const [selectedInvoice, setSelectedInvoice] = useState(0);

    return (
        <>
            {invoices.length > 1 && (
                <Box sx={{ pb: 6, display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {invoices.map((item, index) => (
                            <Chip
                                key={item.name}
                                label={item.name}
                                icon={<Receipt />}
                                variant={selectedInvoice === index ? 'outlined' : 'filled'}
                                onClick={() => {
                                    setSelectedInvoice(index);
                                }}
                                sx={[
                                    selectedInvoice === index
                                        ? {}
                                        : { border: '1px solid transparent' },
                                    {
                                        '& .MuiChip-icon': {
                                            marginLeft: '5px',
                                        },
                                        'textTransform': 'uppercase',
                                    },
                                ]}
                            />
                        ))}
                    </Box>
                    <Box sx={{ flexShrink: 0 }}>
                        <Pagination
                            count={invoices.length}
                            page={selectedInvoice + 1}
                            onChange={(_e, value) => setSelectedInvoice(value - 1)}
                        />
                    </Box>
                </Box>
            )}
            <embed
                src={`${awsURL}/get-file?object_key=${encodeURIComponent(
                    invoices[selectedInvoice].filename
                )}&bucket_name=${bucket_name}#navpanes=0&zoom=page-width`}
                style={{ height: '100%', width: '100%', flexGrow: 1 }}
            />
        </>
    );
};
